import { NavLink } from "react-router-dom"
import style from "./ConfigurationTabs.module.scss"

const { configurationTabs, ul, li, active, nested } = style

export const ConfigurationTabs = () => {
	const showModelNumbers = import.meta.env.VITE_LOCK_QUOTATION_FEATURE !== "true"

	return (
		<nav className={configurationTabs}>
			<ul className={ul}>
				{showModelNumbers ? (
					<li>
						<NavLink to="/configuration/model-numbers" className={({ isActive }) => `${li} ${isActive ? active : ""}`}>
							<span>Model numbers</span>
						</NavLink>
					</li>
				) : null}
				<li>
					<NavLink to="/configuration/keywords" className={({ isActive }) => `${li} ${isActive ? active : ""}`}>
						<span>Keywords</span>
					</NavLink>
				</li>
				<li>
					<NavLink to="/configuration/objects" className={({ isActive }) => `${li} ${isActive ? active : ""}`}>
						<span>Objects</span>
					</NavLink>
					<ul>
						<li>
							<NavLink
								to="/configuration/dimensions-tolerance"
								className={({ isActive }) => `${li} ${nested} ${isActive ? active : ""}`}
							>
								<span>Dimensions tolerance</span>
							</NavLink>
						</li>
						<li>
							<NavLink
								to="/configuration/competitors-model-numbers"
								className={({ isActive }) => `${li} ${nested} ${isActive ? active : ""}`}
							>
								<span>Competitors model numbers</span>
							</NavLink>
						</li>
					</ul>
				</li>
				<li>
					<NavLink to="/configuration/ai-instructions" className={({ isActive }) => `${li} ${isActive ? active : ""}`}>
						<span>AI Instructions</span>
					</NavLink>
				</li>
			</ul>
		</nav>
	)
}
